<template>
  <button
    class="btn w-100 text-center rounded-pill generate-button group relative py-2 px-4 font-medium text-white bg-gradient-to-r from-[#363166] to-[#4b4589] transition-all duration-300 transform hover:scale-[1.02] hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-[#363166] focus:ring-offset-2 overflow-hidden"
    style="background-color: #363166; color: white; cursor: pointer"
  >
    <span class="relative z-10 flex items-center justify-center">
      Generate with SA-I
      <span class="ml-1">
        <i class="fa-solid fa-rocket"></i>
      </span>
    </span>

    <!-- Gradient overlay on hover -->
    <span
      class="absolute inset-0 w-full h-full bg-gradient-to-r from-[#4b4589] to-[#363166] opacity-0 transition-opacity duration-300 group-hover:opacity-100"
    ></span>

    <!-- Subtle border -->
    <span
      class="absolute -inset-px rounded-pill border-2 border-white border-opacity-10"
    ></span>

    <!-- Ripple effect -->
    <span
      class="absolute inset-0 w-full h-full transition-all duration-300 ease-out scale-0 rounded-full bg-white opacity-30 group-hover:scale-100 group-hover:opacity-0"
    ></span>

    <!-- Particle effects -->
    <span class="particle-1"></span>
    <span class="particle-2"></span>
    <span class="particle-3"></span>
  </button>
</template>

<script>
export default {
  methods: {
    generateDescription() {
      // Your existing function
    },
  },
}
</script>

<style>
/* Particle animations */
.particle-1,
.particle-2,
.particle-3 {
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  pointer-events: none;
  opacity: 0;
}

.particle-1 {
  top: 20%;
  left: 20%;
}

.particle-2 {
  top: 30%;
  right: 20%;
}

.particle-3 {
  bottom: 30%;
  left: 50%;
}

.generate-button:hover .particle-1 {
  animation: float-up 1.5s ease-out;
}

.generate-button:hover .particle-2 {
  animation: float-up 2s ease-out 0.2s;
}

.generate-button:hover .particle-3 {
  animation: float-up 1.8s ease-out 0.4s;
}

@keyframes float-up {
  0% {
    transform: translateY(0) scale(0);
    opacity: 0;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    transform: translateY(-20px) scale(1.5);
    opacity: 0;
  }
}

/* Shine effect */
.generate-button::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.3) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  z-index: 1;
  transition: left 0.7s;
}

.generate-button:hover::after {
  left: 100%;
}

/* Add subtle texture */
.generate-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M54.627 0l.83.828-1.415 1.415L51.8 0h2.827zM5.373 0l-.83.828L5.96 2.243 8.2 0H5.374zM48.97 0l3.657 3.657-1.414 1.414L46.143 0h2.828zM11.03 0L7.372 3.657 8.787 5.07 13.857 0H11.03zm32.284 0L49.8 6.485 48.384 7.9l-7.9-7.9h2.83zM16.686 0L10.2 6.485 11.616 7.9l7.9-7.9h-2.83zm20.97 0l9.315 9.314-1.414 1.414L34.828 0h2.83zM22.344 0L13.03 9.314l1.414 1.414L25.172 0h-2.83zM32 0l12.142 12.142-1.414 1.414L30 .828 17.272 13.556l-1.414-1.414L28 0h4zM.284 0l28 28-1.414 1.414L0 2.544V0h.284zM0 5.373l25.456 25.455-1.414 1.415L0 8.2V5.374zm0 5.656l22.627 22.627-1.414 1.414L0 13.86v-2.83zm0 5.656l19.8 19.8-1.415 1.413L0 19.514v-2.83zm0 5.657l16.97 16.97-1.414 1.415L0 25.172v-2.83zM0 28l14.142 14.142-1.414 1.414L0 30.828V28zm0 5.657L11.314 44.97 9.9 46.386l-9.9-9.9v-2.828zm0 5.657L8.485 47.8 7.07 49.212 0 42.143v-2.83zm0 5.657l5.657 5.657-1.414 1.415L0 47.8v-2.83zm0 5.657l2.828 2.83-1.414 1.413L0 53.456v-2.83zM54.627 60L30 35.373 5.373 60H8.2L30 38.2 51.8 60h2.827zm-5.656 0L30 41.03 11.03 60h2.828L30 43.858 46.142 60h2.83zm-5.656 0L30 46.686 16.686 60h2.83L30 49.515 40.485 60h2.83zm-5.657 0L30 52.343 22.344 60h2.83L30 55.172 34.828 60h2.83zM32 60l-2-2-2 2h4zM59.716 0l-28 28 1.414 1.414L60 2.544V0h-.284zM60 5.373L34.544 30.828l1.414 1.415L60 8.2V5.374zm0 5.656L37.373 33.656l1.414 1.414L60 13.86v-2.83zm0 5.656l-19.8 19.8 1.415 1.413L60 19.514v-2.83zm0 5.657l-16.97 16.97 1.414 1.415L60 25.172v-2.83zM60 28L45.858 42.142l1.414 1.414L60 30.828V28zm0 5.657L48.686 44.97l1.415 1.415 9.9-9.9v-2.828zm0 5.657L51.515 47.8l1.414 1.413 7.07-7.07v-2.83zm0 5.657l-5.657 5.657 1.414 1.415L60 47.8v-2.83zm0 5.657l-2.828 2.83 1.414 1.413L60 53.456v-2.83zM39.9 16.385l1.414-1.414L30 3.658 18.686 14.97l1.415 1.415 9.9-9.9 9.9 9.9zm-2.83 2.828l1.415-1.414L30 9.313 21.515 17.8l1.414 1.413L30 11.8l7.07 7.414z' fill='%23ffffff' fill-opacity='0.05' fill-rule='evenodd'/%3E%3C/svg%3E");
  opacity: 0.3;
  z-index: 0;
}

/* Add pulse effect on active state */
.generate-button:active {
  transform: scale(0.98);
}

.generate-button:active::before {
  animation: pulse 0.3s ease-out;
}

@keyframes pulse {
  0% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.3;
  }
}
</style>
